import React,{useEffect} from 'react'

import Services from './Services';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';
import "./Servicespagesection.css";
import Cosection from '../components/Cosections';
const Businessservicespage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      useEffect(() => {
        const items = document.querySelectorAll('.timeline li');
    
        function isElementInViewport(el) {
          const rect = el.getBoundingClientRect();
          return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
              (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
        }
    
        function callbackFunc() {
          for (let i = 0; i < items.length; i++) {
            if (isElementInViewport(items[i])) {
              items[i].classList.add('in-view');
            }
          }
        }
    
        window.addEventListener('load', callbackFunc);
        window.addEventListener('resize', callbackFunc);
        window.addEventListener('scroll', callbackFunc);
    
        return () => {
          window.removeEventListener('load', callbackFunc);
          window.removeEventListener('resize', callbackFunc);
          window.removeEventListener('scroll', callbackFunc);
        };
      }, []);
      const services = {
        business: [
            { 
                title: 'Business Incorporation', 
                description: 'Your gateway to seamless business formation in the USA. Expert guidance, affordable fees, and a streamlined process. Schedule your FREE consultation today!', 
                link: '/business' 
            },
            { 
                title: 'Business Tax Returns', 
                description: 'Expert tax filing for businesses and individuals. Comprehensive services, personalized approach, and commitment to compliance.', 
                link: '/businessreturns' 
            },
            { 
                title: 'Accounting And Book Keeping Services', 
                description: 'Your reliable partner for accounting and bookkeeping using QuickBooks and Xero. Keep your finances organized and tax-ready with our expert support.', 
                link: '/Bookkeeping' 
            },
            { 
                title: 'Payroll Processing Services', 
                description: 'Simplify payroll with Gusto and ADP. Ensure compliance with U.S. tax laws and save time while focusing on your business growth.', 
                link: '/payroll' 
            },
            { 
                title: 'International Business Tax Forms', 
                description: 'Navigate U.S. tax requirements for international businesses. Get expert help with forms like 5471, 5472, and 8865 to ensure compliance and accurate reporting.', 
                link: '/international' 
            },
            { 
                title: 'BOIR', 
                description: 'Comply with U.S. regulations for BOIR filings. Accurately report beneficial ownership information to meet federal requirements and avoid penalties.', 
                link: '/boir' 
            },
        ],
    };
    
  return (
    <div>
       <div>
     <Upperbox/>
      <NavBar/>
      <div className="banner-section">
      <div className="banner-overlay">
        <h1 className="banner-title">Business Services</h1>
      </div>
    </div>
    <div>
       <div className="bgservices">
        <section className="timeline">
          <ul>
            {services.business.map((service, index) => (
              <li key={index}>
                <div>
                  <time>{service.title}</time>
                  {service.description}
                  <br />
                  <Link to={service.link} className="readmore-link">
                    Read more <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>

      


      <Cosection />
    </div>
<Whatsapp/>
<ScrollTop/>
    <Footer/>
    </div>
    </div>
  )
}

export default Businessservicespage
